import axios from "axios";
import { APIS } from "../../../../../../../utils/api-factory"
import {TENANT_POST_HEADER, MULTIPART_TENANT_POST_HEADER, TENANT_HEADER} from "../../../../../../../utils/apiHeaders"
// import {
//   APIS,
//   TENANT_POST_HEADER,
//   MULTIPART_TENANT_POST_HEADER,
// } from "../../../../Common/api-factory";
export const getAllCredTransactions = (callBack, onError) => {
  fetch(APIS.CRED_TRANSACTIONS_ALL, { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};
export const getAllCredTransactionsByMonth = (month, callBack, onError) => {
  fetch(APIS.CRED_TRANSACTIONS_ALL_MONTH + (month ?? ""), {
    headers: TENANT_POST_HEADER,
  })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};
export const getAllCredTransactionsByFilter = (
  debitBool,
  callBack,
  onError,
) => {
  fetch(APIS.CRED_TRANSACTION_FILTER + (debitBool ?? false), {
    headers: TENANT_POST_HEADER,
  })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};
export const getAllCredTransactionsBySearch = (search, callBack, onError) => {
  fetch(APIS.CRED_TRANSACTIONS_SEARCH_TEXT + `${search}`, {
    headers: TENANT_POST_HEADER,
  })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};
export const getAllExpenseCategories = (sDate, eDate, callBack, onError) => {
  const url = `${APIS.GET_ALL_EXPENSE_CATEGORY}?sDate=${sDate}&eDate=${eDate}`;
  fetch(url, { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};

export const getAllExpenses = (callBack, onError) => {
  fetch(APIS.GET_ALL_EXPENSE_CATEGORY, { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};
export const getAllDescription = (callBack, onError) => {
  fetch(APIS.GET_ALL_DESCRIPTION, { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};
export const getTransactionMapping = (tabValue, callBack, onError) => {
  fetch(
    APIS.CRED_TRANSACTION_MAPPING + `${tabValue === "maped" ? true : false}`,
    { headers: TENANT_POST_HEADER },
  )
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};
export const addTransactionCsvFile = (file, callBack, onError) => {
  const formData = new FormData();
  formData.append("file", file);
  console.log(formData);
  axios
    .post(APIS.SAVE_TRANSACTION_BY_CSV, formData, {
      headers: MULTIPART_TENANT_POST_HEADER,
    })
    .then((json) => {
      callBack(json.data);
    })
    .catch((e) => {
      console.log(e);
      onError("Try again");
    });
};
export const getAllSubCategory = (callBack, onError) => {
  fetch(APIS.GET_ALL_EXPENSE_SUB_CATEGORY, { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};
export const getSortedCredTransactions = (
  sortBy,
  dataType,
  callBack,
  onError,
) => {
  fetch(APIS.GET_SORT_CRED_TRANSACTION + `${sortBy}&order=${dataType}`, {
    headers: TENANT_POST_HEADER,
  })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};
export const getBuisnessStatement = (callBack, onError) => {
  fetch(APIS.GET_Business_Statement, { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};
export const getProduct = (callBack, onError) => {
  fetch(APIS.SAVE_PRODUCT, { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};
export const saveProduct = (payload, callBack, onError) => {
  axios
    .post(APIS.SAVE_PRODUCT, payload, {
      headers: TENANT_POST_HEADER,
    })
    .then((response) => {
      callBack(response.data);
    })
    .catch((error) => {
      onError(error);
    });
};
export const calculateProduct = (payload, callBack, onError) => {
  axios
    .post(APIS.GET_MONTHLY_CASHFLOW, payload, {
      headers: TENANT_POST_HEADER,
    })
    .then((response) => {
      callBack(response.data);
    })
    .catch((error) => {
      onError(error);
    });
};
export const saveCategoryForTransaction = (payload, callBack, onError) => {
  axios
    .post(APIS.SAVE_TRANSACTION_CATEGORY, payload, {
      headers: TENANT_POST_HEADER,
    })
    .then((response) => {
      console.log("Response:", response.data);
      callBack(response.data);
    })
    .catch((error) => {
      console.error("Error:", error);
      onError(error);
    });
};

export const getExpenseStatement = (callBack, onError) => {
  fetch(APIS.EXPENSE_STATEMENT, { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};

export const getCombineStats = (callBack, onError) => {
  fetch(APIS.GET_COMBINE_STATS, { method: "post", headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};
export const getCashFlowStatement = (callBack, onError) => {
  fetch(APIS.GET_CASHFLOW_STATEMENT, { headers: TENANT_POST_HEADER })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};
export const getRemainingSummary = (startDate, endDate, callBack, onError) => {
  fetch(`${APIS.GET_REPORT_REMAINING_SUMMARY}${startDate}&endDate=${endDate}`, {
    headers: TENANT_POST_HEADER,
  })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};
export const getAnnualTotalReport = (startDate, endDate, callBack, onError) => {
  fetch(`${APIS.GET_REPORT_MAIN}${startDate}&endDate=${endDate}`, {
    headers: TENANT_POST_HEADER,
  })
    .then((res) => res.json())
    .then((json) => {
      callBack(json);
    })
    .catch((e) => {
      onError(e);
    });
};

// Expense Actual, Forecast, and Deviation APIs
export const saveExpenseActual = (payload, callBack, onError) => {
  console.log("💰 saveExpenseActual called with payload:", payload);
  console.log("Making POST request to:", APIS.EXPENSE_ACTUAL);

  axios
    .post(APIS.EXPENSE_ACTUAL, payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Tenant-ID": "cf",
      },
    })
    .then((response) => {
      console.log(
        "✅ saveExpenseActual success:",
        response.status,
        response.data,
      );
      callBack(response.data);
    })
    .catch((error) => {
      console.error("❌ saveExpenseActual error:", error);

      // Enhanced error logging for 500 errors
      if (error.response) {
        console.error("❌ Error Status:", error.response.status);
        console.error("❌ Error Headers:", error.response.headers);
        console.error("❌ Error Data:", error.response.data);
        console.error("❌ Error Config:", error.config);

        // Try to extract more details from 500 error
        if (error.response.status === 500) {
          console.error("🔥 Server Error Details:");
          console.error("- Request URL:", error.config.url);
          console.error("- Request Method:", error.config.method);
          console.error("- Request Headers:", error.config.headers);
          console.error("- Request Data:", error.config.data);
          console.error("- Response Data:", error.response.data);

          // Check if it's a validation error disguised as 500
          if (error.response.data && typeof error.response.data === "object") {
            console.error(
              "- Possible Validation Errors:",
              error.response.data.errors || error.response.data.message,
            );
          }
        }
      }

      onError(error);
    });
};

export const getExpenseActual = (startDate, endDate, callBack, onError) => {
  console.log("getExpenseActual called with:", { startDate, endDate });
  const url = `${APIS.EXPENSE_ACTUAL}?from=${startDate}&to=${endDate}`;
  console.log("Making request to:", url);

  axios
    .get(url, {
      headers: TENANT_POST_HEADER,
    })
    .then((response) => {
      console.log("getExpenseActual success:", response.status);
      callBack(response.data);
    })
    .catch((error) => {
      console.error("getExpenseActual error:", error);
      onError(error);
    });
};

export const saveExpenseForecast = (payload, callBack, onError) => {
  console.log("📊 saveExpenseForecast called with payload:", payload);
  console.log("Making POST request to:", APIS.EXPENSE_FORECAST);

  axios
    .post(APIS.EXPENSE_FORECAST, payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Tenant-ID": "cf",
      },
    })
    .then((response) => {
      console.log(
        "✅ saveExpenseForecast success:",
        response.status,
        response.data,
      );
      callBack(response.data);
    })
    .catch((error) => {
      console.error("❌ saveExpenseForecast error:", error);
      onError(error);
    });
};

export const getExpenseForecast = (startDate, endDate, callBack, onError) => {
  console.log("getExpenseForecast called with:", { startDate, endDate });
  const url = `${APIS.EXPENSE_FORECAST}?from=${startDate}&to=${endDate}`;
  console.log("Making request to:", url);

  axios
    .get(url, {
      headers: TENANT_POST_HEADER,
    })
    .then((response) => {
      console.log("getExpenseForecast success:", response.status);
      callBack(response.data);
    })
    .catch((error) => {
      console.error("getExpenseForecast error:", error);
      onError(error);
    });
};

export const saveExpenseDeviation = (payload, callBack, onError) => {
  axios
    .post(APIS.EXPENSE_DEVIATION, payload, {
      headers: TENANT_POST_HEADER,
    })
    .then((response) => {
      callBack(response.data);
    })
    .catch((error) => {
      onError(error);
    });
};

export const saveBulkExpenseDeviation = (payload, callBack, onError) => {
  console.log("💰 saveBulkExpenseDeviation called with payload:", payload);
  console.log("Making POST request to:", APIS.EXPENSE_BULK_DEVIATION);

  axios
    .post(APIS.EXPENSE_BULK_DEVIATION, payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Tenant-ID": "cf",
      },
    })
    .then((response) => {
      console.log(
        "✅ saveBulkExpenseDeviation success:",
        response.status,
        response.data,
      );
      callBack(response.data);
    })
    .catch((error) => {
      console.error("❌ saveBulkExpenseDeviation error:", error);

      // Enhanced error logging for 500 errors
      if (error.response) {
        console.error("❌ Error Status:", error.response.status);
        console.error("❌ Error Headers:", error.response.headers);
        console.error("❌ Error Data:", error.response.data);
        console.error("❌ Error Config:", error.config);

        // Try to extract more details from 500 error
        if (error.response.status === 500) {
          console.error("🔥 Server Error Details:");
          console.error("- Request URL:", error.config.url);
          console.error("- Request Method:", error.config.method);
          console.error("- Request Headers:", error.config.headers);
          console.error("- Request Data:", error.config.data);
          console.error("- Response Data:", error.response.data);

          // Check if it's a validation error disguised as 500
          if (error.response.data && typeof error.response.data === "object") {
            console.error(
              "- Possible Validation Errors:",
              error.response.data.errors || error.response.data.message,
            );
          }
        }
      }

      onError(error);
    });
};

export const getExpenseDeviation = (month, callBack, onError) => {
  console.log("getExpenseDeviation called with:", { month });
  console.log("Month type:", typeof month);
  console.log("Month length:", month?.length);
  console.log(
    "Month char codes:",
    month ? Array.from(month).map((c) => c.charCodeAt(0)) : "undefined",
  );

  // Support both month parameter and startDate/endDate parameters
  let url = APIS.EXPENSE_DEVIATION;

  if (month) {
    // Replace space with %20 manually to avoid double encoding
    const encodedMonth = month.replace(" ", "%20");
    console.log("Original month:", month);
    console.log("Encoded month:", encodedMonth);
    url += `?month=${encodedMonth}`;
  } else {
    // If no month provided, use current month
    const currentDate = new Date();
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const currentMonth = `${monthNames[currentDate.getMonth()]} ${currentDate.getFullYear()}`;
    const encodedMonth = currentMonth.replace(" ", "%20");
    url += `?month=${encodedMonth}`;
  }

  console.log("📡 Final URL:", url);
  console.log("📡 URL length:", url.length);
  console.log(
    "📡 URL char codes around month:",
    url
      .substring(url.indexOf("month=") + 6, url.indexOf("month=") + 20)
      .split("")
      .map((c) => c.charCodeAt(0)),
  );

  axios
    .get(url, {
      headers: TENANT_POST_HEADER,
    })
    .then((response) => {
      console.log("getExpenseDeviation success:", response.status);
      callBack(response.data);
    })
    .catch((error) => {
      console.error("getExpenseDeviation error:", error);
      onError(error);
    });
};

export const addCategoryComment = (data, callBack, onError) => {
  axios
    .post(APIS.GET_COMMENT, data, {
      headers: TENANT_POST_HEADER,
    })
    .then((response) => {
      callBack(response.data);
    })
    .catch((error) => {
      onError(error);
    });
};

export const getExpenseForecastComparision = (
  startDate,
  endDate,
  callBack,
  onError,
) => {
  const url = APIS.FORECAST_COMPARISION + `?from=${startDate}&to=${endDate}`;

  axios
    .get(url, {
      headers: {
        "X-Tenant-ID": "cf",
      },
    })
    .then((response) => {
      callBack(response.data);
    })
    .catch((error) => {
      onError(error);
    });
};
// Save Expense Direct (using expense/saveExpense)
export const saveExpenseDirect = (payload, callBack, onError) => {
  console.log("saveExpenseDirect called with payload:", payload);
  console.log("Making request to:", APIS.SAVE_EXPENSE_DIRECT);

  axios
    .post(APIS.SAVE_EXPENSE_DIRECT, payload, {
      headers: TENANT_POST_HEADER,
    })
    .then((response) => {
      console.log("saveExpenseDirect success:", response.status);
      callBack(response.data);
    })
    .catch((error) => {
      console.error("saveExpenseDirect error:", error);
      onError(error);
    });
};

// Get Expense Actual Direct
export const getExpenseActualDirect = (
  startDate,
  endDate,
  callBack,
  onError,
) => {
  console.log("getExpenseActualDirect called with:", { startDate, endDate });
  const url = `${APIS.GET_EXPENSE_ACTUAL_DIRECT}?startDate=${startDate}&endDate=${endDate}`;
  console.log("Making request to:", url);

  axios
    .get(url, {
      headers: TENANT_POST_HEADER,
    })
    .then((response) => {
      console.log("getExpenseActualDirect success:", response.status);
      callBack(response.data);
    })
    .catch((error) => {
      console.error("getExpenseActualDirect error:", error);
      onError(error);
    });
};

// Get Expense Forecast Direct
export const getExpenseForecastDirect = (
  startDate,
  endDate,
  callBack,
  onError,
) => {
  console.log("getExpenseForecastDirect called with:", { startDate, endDate });
  const url = `${APIS.GET_EXPENSE_FORECAST_DIRECT}?startDate=${startDate}&endDate=${endDate}`;
  console.log("Making request to:", url);

  axios
    .get(url, {
      headers: TENANT_POST_HEADER,
    })
    .then((response) => {
      console.log("getExpenseForecastDirect success:", response.status);
      callBack(response.data);
    })
    .catch((error) => {
      console.error("getExpenseForecastDirect error:", error);
      onError(error);
    });
};

// Get Expense Deviation Direct
export const getExpenseDeviationDirect = (month, callBack, onError) => {
  console.log("getExpenseDeviationDirect called with:", { month });
  let url = APIS.GET_EXPENSE_DEVIATION_DIRECT;

  if (month) {
    url += `?month=${encodeURIComponent(month)}`;
  } else {
    const currentDate = new Date();
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const currentMonth = `${monthNames[currentDate.getMonth()]} ${currentDate.getFullYear()}`;
    url += `?month=${encodeURIComponent(currentMonth)}`;
  }

  console.log("Making request to:", url);

  axios
    .get(url, {
      headers: TENANT_POST_HEADER,
    })
    .then((response) => {
      console.log("getExpenseDeviationDirect success:", response.status);
      callBack(response.data);
    })
    .catch((error) => {
      console.error("getExpenseDeviationDirect error:", error);
      onError(error);
    });
};

// ========== BUDGET PLANNING APIs ==========

// Save Budget Planning Data
export const saveBudgetPlanning = (payload, callBack, onError) => {
  axios
    .post(APIS.BUDGET_PLANNING_SAVE, payload, {
      headers: TENANT_POST_HEADER,
    })
    .then((response) => {
      callBack(response.data);
    })
    .catch((error) => {
      onError(error);
    });
};

// Get Budget Planning Data
export const getBudgetPlanning = (startDate, endDate, callBack, onError) => {
  const url = `${APIS.BUDGET_PLANNING_GET}?startDate=${startDate}&endDate=${endDate}`;
  axios
    .get(url, {
      headers: TENANT_POST_HEADER,
    })
    .then((response) => {
      callBack(response.data);
    })
    .catch((error) => {
      onError(error);
    });
};

// Save Budget Target
export const saveBudgetTarget = (payload, callBack, onError) => {
  axios
    .post(APIS.BUDGET_TARGET_SAVE, payload, {
      headers: TENANT_POST_HEADER,
    })
    .then((response) => {
      callBack(response.data);
    })
    .catch((error) => {
      onError(error);
    });
};

// Get Budget Target
export const getBudgetTarget = (startDate, endDate, callBack, onError) => {
  const url = `${APIS.BUDGET_TARGET_GET}?startDate=${startDate}&endDate=${endDate}`;
  axios
    .get(url, {
      headers: TENANT_POST_HEADER,
    })
    .then((response) => {
      callBack(response.data);
    })
    .catch((error) => {
      onError(error);
    });
};

// Save Budget Allocation
export const saveBudgetAllocation = (payload, callBack, onError) => {
  axios
    .post(APIS.BUDGET_ALLOCATION_SAVE, payload, {
      headers: TENANT_POST_HEADER,
    })
    .then((response) => {
      callBack(response.data);
    })
    .catch((error) => {
      onError(error);
    });
};

// Delete Expense Actual
export const deleteExpenseActual = (id, callBack, onError) => {
  console.log("deleteExpenseActual called with id:", id);
  const url = `${APIS.DELETE_EXPENSE_ACTUAL}${id}`;
  console.log("Making DELETE request to:", url);

  axios
    .delete(url, {
      headers: TENANT_POST_HEADER,
    })
    .then((response) => {
      console.log("deleteExpenseActual success:", response.status);
      callBack(response.data);
    })
    .catch((error) => {
      console.error("deleteExpenseActual error:", error);
      onError(error);
    });
};

// Delete Expense Forecast
export const deleteExpenseForecast = (id, callBack, onError) => {
  console.log("deleteExpenseForecast called with id:", id);
  const url = `${APIS.DELETE_EXPENSE_FORECAST}${id}`;
  console.log("Making DELETE request to:", url);

  axios
    .delete(url, {
      headers: TENANT_POST_HEADER,
    })
    .then((response) => {
      console.log("deleteExpenseForecast success:", response.status);
      callBack(response.data);
    })
    .catch((error) => {
      console.error("deleteExpenseForecast error:", error);
      onError(error);
    });
};

// Update Expense Data
export const updateExpenseData = (id, payload, callBack, onError) => {
  console.log("updateExpenseData called with id:", id, "payload:", payload);
  const url = `${APIS.UPDATE_EXPENSE_DATA}${id}`;
  console.log("Making PUT request to:", url);

  axios
    .put(url, payload, {
      headers: TENANT_POST_HEADER,
    })
    .then((response) => {
      console.log("updateExpenseData success:", response.status);
      callBack(response.data);
    })
    .catch((error) => {
      console.error("updateExpenseData error:", error);
      onError(error);
    });
};

export const getExpenseOverviewByDateRangeFilters = (from, to, accured, callBack, onError) => {

  axios
    .get(APIS.GET_EXPENSE_OVERVIEW_BY_DATE_RANGE_FILTERS + from + "&to=" + to + "&accrued=" + accured, TENANT_HEADER)
    .then((response) => {
      callBack(response.data);
    })
    .catch((error) => {
      onError(error);
    });
};
export const getExpenseTableByDateRangeFilters = (from, to, callBack, onError) => {

  axios
    .get(APIS.GET_EXPENSE_TABLE_BY_DATE_RANGE_FILTERS + from + "&to=" + to , TENANT_HEADER)
    .then((response) => {
      callBack(response.data);
    })
    .catch((error) => {
      onError(error);
    });
};
export const getExpenseDASHboardsummaryByDateRangeFilters = (from, to, callBack, onError) => {

  axios
    .get(APIS.GET_EXPENSE_DASHBOARD_SUMMARY_BY_FILTERS + from + "&to=" + to , TENANT_HEADER)
    .then((response) => {
      callBack(response.data);
    })
    .catch((error) => {
      onError(error);
    });
};
export const getExpenseExpectedIncomeByDateRangeFilters = (from, to, callBack, onError) => {

  axios
    .get(APIS.GET_EXPENSE_EXPECTED_INCOME_SUMMARY_BY_FILTERS + from + "&to=" + to , TENANT_HEADER)
    .then((response) => {
      callBack(response.data);
    })
    .catch((error) => {
      onError(error);
    });
};
export const getExpenseMonthlyTableDASHboardsummaryByDateRangeFilters = (from, to, callBack, onError) => {

  axios
    .get(APIS.GET_EXPENSE_MONTHLY_TABLE_FROM_FILTERS + from + "&to=" + to , TENANT_HEADER)
    .then((response) => {
      callBack(response.data);
    })
    .catch((error) => {
      onError(error);
    });
};

export const getIncomeGrowhtByDateRangeFilters = (from, to,accured, callBack, onError) => {

  axios
    .get(APIS.GET_INCOME_GRWTH_MONTHLY_TABLE_FROM_FILTERS + from + "&to=" + to + "&accrued=" + accured, TENANT_HEADER)
    .then((response) => {
      callBack(response.data);
    })
    .catch((error) => {
      onError(error);
    });
};

